module.exports = __webpack_public_path__ + "img/empty-pic2.ee6e3ed7.png";